import React from "react";
import { InfoIcon, TargetIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { ExpandableList } from "./ExpandableList";
import { volumes } from "../data/volumes";
export function VolumesSection() {
  return <section className="bg-surface px-4 py-16 sm:px-6 sm:py-24" id="volumes" data-id="element-354" data-mp="7po3x442kmuq">
      <div className="mx-auto max-w-6xl" data-id="element-355" data-mp="7nlg8qqe35t6">
        <SectionHeading title={<>
              What will you find inside the <span className="text-navy-700" data-id="element-357" data-mp="3c4fiuvh0ha6n">Blueprint™</span>?
            </>} subtitle="6 specialized volumes to help you organize your knowledge." data-id="element-356" data-mp="3g69f8rk6bs10" />

        <div className="mt-12 grid items-start gap-6 lg:grid-cols-2" data-id="element-358" data-mp="3l4kpv4iam6ka">
          {volumes.map(({
          numeral,
          icon: Icon,
          title,
          tagline,
          intro,
          topics,
          objective,
          note
        }) => <article key={numeral} className="flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-navy-900/5" data-id="element-359" data-mp="2xcngdk2bfqmc">
              <div className="flex items-center gap-4 bg-navy-900 px-6 py-5 text-white" data-id="element-360" data-mp="29ga981atzxtz">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent text-navy-950" data-id="element-361" data-mp="2ee1zkqvtvbw2">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-362" data-mp="2j6d1fza4p7r9" />
                </span>
                <div data-id="element-363" data-mp="2o4o8y3cyb66b">
                  <p className="font-display text-sm font-semibold uppercase tracking-widest text-accent" data-id="element-364" data-mp="2o33h4li0u1c5">Volume {numeral}</p>
                  <h3 className="font-display text-xl font-bold uppercase leading-tight sm:text-2xl" data-id="element-365" data-mp="1qiqymt8q675g">{title}</h3>
                </div>
              </div>

              <div className="flex flex-1 flex-col px-6 py-6" data-id="element-366" data-mp="20ekf2npkeksi">
                <p className="text-lg font-bold leading-snug text-ink" data-id="element-367" data-mp="24gfjw26pfgb1">{tagline}</p>
                <p className="mt-3 text-base leading-relaxed text-ink-soft" data-id="element-368" data-mp="24eb70uqtv6ym">{intro}</p>
                <p className="mt-5 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-369" data-mp="3btposbo45jlm">Inside, you'll explore:</p>
                <div className="mt-3" data-id="element-370" data-mp="3fxf8ampxlazs">
                  <ExpandableList items={topics} data-id="element-371" data-mp="1gq1emmcipyql" />
                </div>

                <div className="mt-auto space-y-3 pt-6" data-id="element-372" data-mp="1brq3876krg69">
                  <div className="flex gap-3 rounded-2xl bg-accent-soft p-4" data-id="element-373" data-mp="1br7w2fidjhjk">
                    <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-700" aria-hidden="true" data-id="element-374" data-mp="1pqg1hq54rlw7" />
                    <p className="text-sm leading-relaxed text-ink" data-id="element-375" data-mp="1ktplt3x8msbb">
                      <strong data-id="element-376" data-mp="x2bsovr9ispa">The objective:</strong> {objective}
                    </p>
                  </div>
                  {note && <div className="flex gap-3 rounded-2xl bg-alert-soft p-4" data-id="element-377" data-mp="t2ta46mwytpm">
                      <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-378" data-mp="16tojdk1brctq" />
                      <p className="text-sm leading-relaxed text-ink" data-id="element-379" data-mp="120ve8v1y22h4">{note}</p>
                    </div>}
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-380" data-mp="9chea9raow2x">
          <CtaButton label="Access all 6 volumes now" data-id="element-381" data-mp="9beqwbt6lbrr" />
        </div>
      </div>
    </section>;
}